import request from '@/utils/request'
const BASE_URL = '/Other'

export default {
  list(data) {
    return request({
      url: BASE_URL + '/List',
      method: 'post',
      data
    })
  },
  save(data) {
    return request({
      url: BASE_URL + '/Save',
      method: 'post',
      data
    })
  },
  info(id) {
    return request({
      url: BASE_URL + '/Info',
      method: 'get',
      params: { id }
    })
  },
  delete(data) {
    return request({
      url: BASE_URL + '/Delete',
      method: 'post',
      data
    })
  },
  get(data) {
    return request({
      url: BASE_URL + '/Get',
      method: 'post',
      data
    })
  },
  getMaxSn(OtherType) {
    return request({
      url: BASE_URL + '/getMaxSn',
      method: 'get',
      params: { OtherType }
    })
  },
}